import { Injectable } from '@angular/core';
import { GfTranslateService } from '../../core/services/core.translate.service';

import * as moment from 'moment';

const TYPE_DAYS = 1;
const TYPE_WEEKS = 2;
const TYPE_MONTHS = 4;
const TYPE_YEARS = 5;

@Injectable()
export class ReminderHelper {

    constructor(private gfTranslateService: GfTranslateService) { }

    getBlankReminder(section: string, refId: number) {
        return {
            section: section,
            refId: refId,
            label: '',
            comments: '',
            schedulingType: TYPE_DAYS,
            schedulingValue: 1,
            targetDate: this.getDateString(moment().add(0, 'days')),
            notifyUsers: []
        };
    }

    getDateString(m) {
        const FORMAT: string = 'YYYY-MM-DD';
        return m.format(FORMAT);
    }

    getSchedulingTypes() {
        var ret: any = {};
        ret[this.gfTranslateService.translate('Days')] = TYPE_DAYS;
        ret[this.gfTranslateService.translate('Weeks')] = TYPE_WEEKS;
        ret[this.gfTranslateService.translate('Months')] = TYPE_MONTHS;
        ret[this.gfTranslateService.translate('Years')] = TYPE_YEARS;
        return ret;
    }

    getTargetDate(countValue: any = 0, schedulingType: any = TYPE_DAYS) {
        if (countValue == 0) {
            return this.getDateString(moment());
        }

        var periodValue: string = 'days';
        switch (schedulingType) {
            case TYPE_WEEKS:
                periodValue = 'weeks';
                break;

            case TYPE_MONTHS:
                periodValue = 'months';
                break;

            case TYPE_YEARS:
                periodValue = 'years';
                break;
        }

        return this.getDateString(moment().add(countValue, periodValue));
    }
}